import "./modules/common";
import PressOfficeType from "~/Components/PressOffice/PressOfficeType.vue";
import PressOfficeCard from "~/Components/PressOffice/PressOfficeCard.vue";
import PersonCard from "~/Components/People/PersonCard.vue";
import SearchPagination from "~/Components/Search/SearchPagination.vue";
import VueApp from "~/Scripts/new/vueApp";

new VueApp( {
  name: "PressOffice",
  components: {
    PressOfficeType,
    PressOfficeCard,
    PersonCard,
    SearchPagination,
  },
} );
